<!-- 柱状图 -->
<style lang="stylus" scoped>
.bar-wrap {
  width: 100%;
  height: 274px;
  padding: 18px 0;
  overflow: hidden;
  .swiper-wrap{
    height: 274px;
  }

  .swiper-slide{
    height: 36px;
  }
  .list {
    color: #fff;
    margin-top: 25px;
    margin-left: 32px;

    .list-item {
      display: flex;
      // margin-bottom: 15px;
      height: 36px;
      line-height: 36px;

      .name {
        margin-right: 15px;
        font-size: 18px;
        width: 108px;
        text-align: left;
        color:rgba(0,254,251,1);
      }

      .length {
        margin-right: 10px;
        margin-top: 14px;
        width: 168px;
        height: 8px;
        background: rgba(255, 181, 43, 0.22);
        .active {
          height: 100%;
          background: linear-gradient(90deg, #5EB5FF, #217DFB);
        }
      }
      .num {
        font-size: 18px;
      }
    }

    .list-item:nth-child(1) .length .active {
      width: 90%;
      background: linear-gradient(90deg, #FCC94A, #FF4E00);
    }

    .list-item:nth-child(2) .length .active {
      width: 70%;
      background: linear-gradient(90deg, #FCC94A, #FF8700);
    }

    .list-item:nth-child(3) .length .active {
      width: 60%;
      background: linear-gradient(90deg, #C0E450, #75CD2D);
    }

    .list-item:nth-child(4) .length .active {
      width: 50%;
    }

    .list-item:nth-child(5) .length .active {
      width: 40%;
    }
  }
}
</style>

<template>
  <boxWrap :name="name">
    <div class="bar-wrap">

      <swiper :options="swiperOption" class="swiper-wrap"  ref="mySwiper" v-if="tableData.length!=0">
        <swiper-slide v-for="(item,index) in tableData" :key="index" class="list">
          <div class="list-item">
            <div class="name">{{item.name}}</div>
            <div class="length">
              <div class="active"></div>
            </div>
            <div class="num">{{item.num}}</div>
          </div>
        </swiper-slide>
      </swiper>

    </div>
  </boxWrap>
</template>

<script>
import echarts from 'echarts'
import boxWrap from 'components/dashboard/common/boxWrap';
import '../../../../static/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
export default {
  data() {
    return {
      color: ['#AF69FF', '#00A0EA', '#13AF68', '#FFB52B', '#920784'],
      myChart: {},
      name: '可追溯商品排名',
      tableData: [
        {name: '百色芒果', num: 15694},
        {name: '圣女果', num: 9525},
        {name: '西林火姜', num: 6978},
        {name: '牛心李', num: 4525}
      ],
      swiperOption: {
        slidesPerView: 'auto',
        // 一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
        notNextTick: true,
        // 循环
        loop: true,
        // 设定初始化时slide的索引
        initialSlide: 0,
        roundLengths: true,
        height: 180,
        // 自动播放
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          /* 触摸滑动后是否继续轮播 */
          disableOnInteraction: false
        },
        // 滑动速度
        speed: 800,
        // 滑动方向
        direction: "vertical",
        // 小手掌抓取滑动
        grabCursor: true
      }
    }
  },
  components: {
    boxWrap,
    swiper,
    swiperSlide
  },
  methods: {
  },
  mounted() {
  }
}

</script>



// WEBPACK FOOTER //
// index.vue?ec6b4c02